<div class="onMobile mobileMenu">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-6">
        <a class="logoMobile" routerLink="/"><img class="logoImg" src="assets/front/images/logo.png" alt="ceratube" width="120" /></a>
      </div>
      <div class="col-6 text-end">
        <button type="button" name="button" class="openMobileMenu" onClick="openMobileMenu(this)"><i class="fa fa-bars" aria-hidden="true"></i></button>
      </div>
    </div>
  </div>
</div>
<div class="mobileMenuContent container-fluid onMobile">
  <div class="row">
    <div class="col-6">
      <a class="logoMobile" routerLink="/"><img class="logoImg" src="assets/front/images/logo.png" alt="ceratube" width="120" /></a>
    </div>
    <div class="col-6 text-end">
      <button type="button" class="closeMenuMobile" name="button" onClick="closeMobileMenu(this)"><i class="fa fa-times" aria-hidden="true"></i></button>
      <button type="button" class="returnF1" name="button"><i class="fa fa-arrow-left"></i></button>
    </div>
    <div class="col-12">
      <nav class="navbar navbar-expand-lg navbar-light principalMenu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Catégories
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item goSanitaire" routerLink="#">Sanitaire</a></li>
              <li><a class="dropdown-item goRobinetterie" routerLink="#">Robinetterie</a></li>
              <li><a class="dropdown-item goCuisine" routerLink="#">Cuisine</a></li>
              <li><a class="dropdown-item goCarrelage" routerLink="#">Carrelage</a></li>
              <li><a class="dropdown-item goPlomberie" routerLink="#">Plomberie</a></li>
              <li><a class="dropdown-item goChauffage" routerLink="#">Chauffage</a></li>
              <li><a class="dropdown-item goAeration" routerLink="#">Aeration, ventilation et isolation</a></li>
              <li><a class="dropdown-item" routerLink="/robimeds" onClick="closeMobileMenu(this)">Robimed®</a></li>
              <!-- <li><a class="dropdown-item" routerLink="/marques" onClick="closeMobileMenu(this)">Marques</a></li> -->
              <!-- <li><a class="dropdown-item" routerLink="/series" onClick="closeMobileMenu(this)">Séries</a></li> -->
            </ul>
          </li>
           <li class="nav-item">
              <a class="nav-link active" aria-current="page" href="https://ceratube.ma/ceratube/catalogue-complet.pdf">Catalogue</a>
           </li>
           <li class="nav-item">
              <a class="nav-link active" aria-current="page" onClick="closeMobileMenu(this)" routerLink="/apropos">Ceratube</a>
           </li>
           <!-- <li class="nav-item">
              <a class="nav-link active" aria-current="page" onClick="closeMobileMenu(this)" routerLink="/inspiration">Inspirations</a>
           </li> -->
           <li class="nav-item">
            <a class="nav-link active" aria-current="page" onClick="closeMobileMenu(this)" routerLink="/promos">Promos</a>
         </li>
           <li class="nav-item">
              <a class="nav-link active" aria-current="page" onClick="closeMobileMenu(this)" routerLink="/contact">Contact</a>
           </li>
           <li class="nav-item"><hr class="dropdown-divider"></li>
           <li class="nav-item">
              <a class="nav-link goSearch active" onClick="closeMobileMenu(this)" aria-current="page" href="javascript: void(0)"><i class="fa fa-search" aria-hidden="true"></i> Recherche</a>
           </li>
           <li class="nav-item">
             <a *ngIf="!isLoged && !isLogedB2c" class="nav-link" routerLink="/connexion" onClick="closeMobileMenu(this)"><i class="fa fa-user-o" aria-hidden="true"></i> S'identifier</a>
             <a *ngIf="isLoged" class="nav-link" routerLink="/b2b" onClick="closeMobileMenu(this)"><i class="fa fa-user-o" aria-hidden="true"></i> Mon compte</a>
             <a *ngIf="isLogedB2c" class="nav-link" routerLink="/moncompte" onClick="closeMobileMenu(this)"><i class="fa fa-user-o" aria-hidden="true"></i> Mon compte</a>
           </li>
           <li class="nav-item">
             <a class="nav-link" routerLink="/favoris" onClick="closeMobileMenu(this)">
               <i class="fa fa-heart-o"></i> Favoris</a>
           </li>
           <li class="nav-item">
             <span class="badge">0</span>
              <a class="nav-link active" aria-current="page" routerLink="/panier" onClick="closeMobileMenu(this)">
                <img src="assets/front/images/cart2.svg" alt="cart"> Panier
              </a>
           </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light carrelagMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',50]" [queryParams]="{nv: 1}">Carrelage effet pierre sol et mur</a>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',51]" [queryParams]="{nv: 1}">Carrelage effet marbre sol et mur</a>
          </li>
          <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',52]" [queryParams]="{nv: 1}">Carrelage effet bois sol et mur 
            </a>
          </li>
         <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',53]" [queryParams]="{nv: 1}"> Carrelage effet beton sol et mur 
            </a>
          </li>
         <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',54]" [queryParams]="{nv: 1}">Carrelage effet pierre mural
            </a>
          </li>
         <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',55]" [queryParams]="{nv: 1}">Carrelage effet marbre mural
            </a>
          </li>
        <li class="nav-item dropdown">
            <a class="dropdown-item" [routerLink]="['products/',56]" [queryParams]="{nv: 1}">
              Carrelage grand format 
            </a>
        </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light sanitaireMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Accessoires de salle de bain et wc
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',45]">Porte brosse a dent</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',46]">Porte brosse wc</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',47]">Porte manteau</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',48]">Porte papier</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',49]">Porte savon</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',50]">Porte serviette</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',51]">Poubelle</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',1]" [queryParams]="{nv: 1}">Accessoires de salle de bain et wc</a></li>
            </ul>
          </li>
          <li class="nav-item"><a [routerLink]="['products/',44]" [queryParams]="{nv: 1}" [queryParams]="{nv: 1}">Meubles de salle de bain</a></li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Lavabo et vasque
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',134]">Lavabo</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',136]">Vasques</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Toilette
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',14]">Cuvette wc suspendue</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',132]">Cuvette wc a poser</a></li>
            </ul>
          </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light robinetterieMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Douche
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',5]">Bras de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',10]">Colonne de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',11]">Combiné de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',17]">Support de douchette</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',21]">Flexible de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',25]">Kit de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',44]">Pomme de douche</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Coin wc
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',1]">Accessoires</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',6]">Broyeurs</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',15]">Descente de chasse</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',16]">Douchette</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',29]">Mécanisme de chasse encastrée</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',30]">Mécanisme de chasse poussoir</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',43]">Plaque de commande</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',90]">Supports</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',13]">Coude et rallonge wc</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',14]">Cuvette wc suspendue</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',132]">Cuvette wc à poser</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Robinetterie de salle de bain encastrable
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',12]">Corps encastré</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',18]">Ensemble de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',19]">Façade encastrée</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',125]">Mitigeurs de lavabo encastré</a></li>
              <!-- <li><a class="dropdown-item" [routerLink]="['products/',33]">Mitigeur de baignoire</a></li> -->
              <!-- <li><a class="dropdown-item" [routerLink]="['products/',40]">Mitigeur de baignoire encastrable</a></li> -->
              <li><a class="dropdown-item" [routerLink]="['products/',124]">Mitigeurs de baignoire encastré</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',38]">Mitigeurs de douche encastré</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Collectivité
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',2]">Accessoires de collectivité</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',4]">Accessoires de robinetterie temporisée</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',26]">Laboratoire</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',41]">Personne à mobilité réduite (pmr)</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',72]">Robinet à pédale</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',73]">Robinet de chasse poussoir</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',74]">Robinet infra rouge</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',76]">Robinet poussoir de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',77]">Robinet poussoir de lavabo</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',75]">Robinet poussoir d'urinoir</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',126]">Douches de collectivité</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',139]">Wc lavabo collectif</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Vidages et siphons
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',88]">Siphon de sol</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',8]">Caniveaux de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',87]">Siphon de lavabo</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',86]">Siphon de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',84]">Siphon de baignoire</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',85]">Siphon de bidet</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Robinetterie de salle de bain
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',3]">Accessoires de robinetterie</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',32]">Mélangeurs</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',35]">Mitigeurs de baignoire</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',36]">Mitigeurs de bidet</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',37]">Mitigeurs de douche</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',39]">Mitigeurs de lavabo</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',81]">Robinets equerres</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',82]">Robinets et becs</a></li>
            </ul>
          </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light cuisineMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item"><a [routerLink]="['products/',39]" [queryParams]="{nv: 1}">Vidages Et Siphons D'Evier</a></li>
          <li class="nav-item"><a [routerLink]="['products/',15]" [queryParams]="{nv: 1}">Eviers</a></li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <a [routerLink]="['products/',110]">Eviers</a>
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',146]">Éviers sous plan</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',145]">Éviers encastrable</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',147]">Éviers à poser</a></li>
            </ul>
          </li>
          <li class="nav-item"><a [routerLink]="['products/',42]" [queryParams]="{nv: 1}">Robinets de cuisine de collectivité</a></li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Robinetterie de cuisine
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',34]">Mitigeurs d'évier</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',31]">Mélangeurs d’évier</a></li>
            </ul>
          </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light plomberieMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item"><a [routerLink]="['products/',3]" [queryParams]="{nv: 1}">Ballon D'Expension Et Membranes</a></li>
          <li class="nav-item"><a [routerLink]="['products/',7]" [queryParams]="{nv: 1}">Collecteurs</a></li>
          <li class="nav-item"><a [routerLink]="['products/',9]" [queryParams]="{nv: 1}">Colliers De Fixation</a></li>
          <li class="nav-item"><a [routerLink]="['products/',10]" [queryParams]="{nv: 1}">Compteurs D'Eau</a></li>
          <li class="nav-item"><a [routerLink]="['products/',12]" [queryParams]="{nv: 1}">Électrovannes et vannes motorisées</a></li>
          <li class="nav-item"><a [routerLink]="['products/',14]" [queryParams]="{nv: 1}">Étanchéité et adhésifs</a></li>
          <li class="nav-item"><a [routerLink]="['products/',23]" [queryParams]="{nv: 1}">Outils Et Machines</a></li>
          <li class="nav-item"><a [routerLink]="['products/',17]" [queryParams]="{nv: 1}">Flexibles</a></li>
          <li class="nav-item"><a [routerLink]="['products/',20]" [queryParams]="{nv: 1}">Gargouilles</a></li>
          <li class="nav-item"><a [routerLink]="['products/',26]" [queryParams]="{nv: 1}">Resistance Et Thermostat</a></li>
          <li class="nav-item"><a [routerLink]="['products/',31]" [queryParams]="{nv: 1}">Rosaces</a></li>
          <li class="nav-item"><a [routerLink]="['products/',33]" [queryParams]="{nv: 1}">Soudure Et Chalumeaux</a></li>
          <li class="nav-item"><a [routerLink]="['products/',37]" [queryParams]="{nv: 1}">Vannes</a></li>
          <li class="nav-item"><a [routerLink]="['products/',40]" [queryParams]="{nv: 1}">Visserie Et Fixation</a></li>
          <li class="nav-item"><a [routerLink]="['products/',43]" [queryParams]="{nv: 1}">Séparateur hydrocarbure</a></li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Tubes Et Raccords De Plomberie
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',55]">Raccords De Climatisation</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',56]">Raccords En Cuivre</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',57]">Raccords En Fonte</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',58]">Raccords en fonte malléable galvanise</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',59]">Raccords en fonte malléable Noir</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',60]">Raccords En Laiton</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',61]">Raccords En Laiton Compteur</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',62]">Raccords En Laiton Ogive</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',63]">Raccords En Laiton Pehd</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',64]">Raccords En Laiton Retube</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',66]">Raccords en laiton retube à sertir </a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',67]">Raccords En Pvc</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',68]">Raccords Ppr</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',92]">Tubes En Cuivre En Barre</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',93]">Tubes En Cuivre En Couronne</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',94]">Tubes En Fonte</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',95]">Tubes Ppr</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',128]">Tubes phonoblack</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',96]">Tubes réticulés</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',123]">Tubes et raccords de plomberie</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Protection Des Installations
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <!-- <li><a class="dropdown-item" [routerLink]="['products/',131]">Protection Des Installations</a></li> -->
              <li><a class="dropdown-item" [routerLink]="['products/',9]">Clapets et crépines</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',20]">Filtre A Tamis</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',28]">Manometres Et Thermometres</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',53]">Purgeurs et contrôleurs d’air </a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',69]">Réducteur de pression </a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',89]">Soupapes</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',135]">Goulottes</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Robinetterie De Batiment
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',78]">Robinet d’arrêt</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',79]">Robinet d’arrosage</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',83]">Robinet flotteur</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',91]">Tetes De Robinet</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',80]">Robinet de puisage</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Accessoires Pour Pompes
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',54]">Raccords 5 voies</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',71]">Régulateur de control </a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',22]">Flotteur électrique</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',52]">Pressostats</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <div class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Traitement Des Eaux Et Assainissement
            </div>
            <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['products/',7]">Caniveaux</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',23]">Fonds De Naissance</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',24]">Fosse Septique</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',42]">Piquages</a></li>
              <li><a class="dropdown-item" [routerLink]="['products/',70]">Regards</a></li>
              <!-- <li><a class="dropdown-item" [routerLink]="['products/',122]">Traitement des eaux et assainissement</a></li> -->
            </ul>
          </li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light chauffageMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item"><a [routerLink]="['products/',4]" [queryParams]="{nv: 1}">Chauffe-eau électrique</a></li>
          <li class="nav-item"><a [routerLink]="['products/',13]" [queryParams]="{nv: 1}">Éléments de radiateur</a></li>
          <li class="nav-item"><a [routerLink]="['products/',25]" [queryParams]="{nv: 1}">Resistance Et Thermostat</a></li>
          <li class="nav-item"><a [routerLink]="['products/',5]" [queryParams]="{nv: 1}">Chauffe Eau Solaire</a></li>
          <li class="nav-item"><a [routerLink]="['products/',21]" [queryParams]="{nv: 1}">Groupe de sécurité</a></li>
          <li class="nav-item"><a [routerLink]="['products/',32]" [queryParams]="{nv: 1}">Sèche serviettes électrique</a></li>
        </ul>
      </nav>
      <nav class="navbar navbar-expand-lg navbar-light aerationMenu f2Menu">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-center">
          <li class="nav-item"><a [routerLink]="['products/',16]" [queryParams]="{nv: 1}">Extracteur d’air</a></li>
          <li class="nav-item"><a [routerLink]="['products/',19]"  [queryParams]="{nv: 1}">Gaine Flexible En Alluminum</a></li>
          <li class="nav-item"><a [routerLink]="['products/',35]" [queryParams]="{nv: 1}">Tubes Isolant Armaflex</a></li>
          <li class="nav-item"><a [routerLink]="['products/',18]" [queryParams]="{nv: 1}">Gaine Calorifuge</a></li>
          <li class="nav-item"><a [routerLink]="['products/',22]" [queryParams]="{nv: 1}">Laine De Verre</a></li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<header class="container-fluid p-0 onDesktop">
      <div class="container-fluid MenuBar p-0">
        <div class="container-fluid container-lg-fluid container-xxl p-0">
          <nav class="navbar navbar-expand-lg navbar-light">
            <!--  Show this only on mobile to medium screens  -->
              <a class="navbar-brand d-lg-none" href="/site"><img class="logoImg" src="assets/front/images/logo.png" alt="ceratube" width="120" /></a>

              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggle" aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
            <!--  Use flexbox utility classes to change how the child elements are justified  -->
              <div class="collapse navbar-collapse justify-content-between" id="navbarToggle">
                <div class="col-5">
                  <ul class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link active" routerLink="/">Accueil <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="https://ceratube.ma/ceratube/catalogue-complet.pdf">Catalogue</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/apropos">Ceratube</a>
                    </li>
                    <!-- <li class="nav-item">
                      <a class="nav-link" routerLink="/inspiration" >Inspirations</a>
                    </li> -->
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/contact">Contact</a>
                    </li>
                  </ul>
              </div>


            <!--   Show this only lg screens and up   -->
            <div class="col-2 text-center">
              <a class="navbar-brand d-none d-lg-block m-0" routerLink="/"><img class="logoImg" src="assets/front/images/logo.png" alt="ceratube" width="120" /></a>
            </div>
            <div class="col-5 text-end">
              <ul class="navbar-nav justify-content-end">
                <li class="nav-item">
                  <a class="nav-link goSearch" href="javascript: void(0)"><i class="fa fa-search" aria-hidden="true"></i> Recherche</a>
                </li>
                <li class="nav-item">
                  <a *ngIf="!isLoged && !isLogedB2c" class="nav-link" routerLink="/connexion"><i class="fa fa-user-o" aria-hidden="true"></i> S'identifier</a>
                  <a *ngIf="isLoged" class="nav-link" routerLink="/b2b"><i class="fa fa-user-o" aria-hidden="true"></i> Mon compte</a>
                  <a *ngIf="isLogedB2c" class="nav-link" routerLink="/moncompte"><i class="fa fa-user-o" aria-hidden="true"></i> Mon compte</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" routerLink="/favoris">
                    <span class="monBadge translate-middle badge rounded-pill bg-danger">{{cartService.favorisCount}}</span>
                    <i class="fa fa-heart-o"></i> Favoris</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" routerLink="/panier">
                    <span class="monBadge translate-middle badge rounded-pill bg-danger">{{cartService.panierCount}}</span>
                    <img src="assets/front/images/cart2.svg" alt="cart"> Panier</a>
                </li>
              </ul>
            </div>
              </div>
            </nav>
        </div>
        <div class="container">
          <div class="theSeparator d-md-none d-lg-block"></div>
          <nav class="navbar secondNav navbar-expand-lg navbar-light justify-content-center">
            <!--  Show this only on mobile to medium screens  -->
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggle" aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
            <ul class="navbar-nav">
                  <li class="nav-item">
                    <a class="nav-link" href="#"></a>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/sanitaireicon.svg"/> Sanitaire</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid cuisineSubMenu">
                          <div class="row justify-content-center">
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',1]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Accessoires de salle de bain et wc</a>
                              <div class="list-group mb-3">
                                <a class="list-group-item" [routerLink]="['products/',45]" onclick="closeCollapse()">Porte brosse à dent</a>
                                <a class="list-group-item" [routerLink]="['products/',46]" onclick="closeCollapse()">Porte brosse wc</a>
                                <a class="list-group-item" [routerLink]="['products/',47]" onclick="closeCollapse()">Porte manteau</a>
                                <a class="list-group-item" [routerLink]="['products/',48]" onclick="closeCollapse()">Porte papier</a>
                                <a class="list-group-item" [routerLink]="['products/',49]" onclick="closeCollapse()">Porte savon</a>
                                <a class="list-group-item" [routerLink]="['products/',50]" onclick="closeCollapse()">Porte serviette</a>
                                <a class="list-group-item" [routerLink]="['products/',51]" onclick="closeCollapse()">Poubelle</a>
                              </div>


                            </div>
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',44]" [queryParams]="{nv: 1}" [queryParams]="{nv: 1}" onclick="closeCollapse()">Meubles de salle de bain</a>
                              <a class="titreSubMenu mb-2">Lavabo et vasque</a>
                              <div class="list-group mb-3">
                                <a class="list-group-item" [routerLink]="['products/',134]" onclick="closeCollapse()">Lavabo</a>
                                <a class="list-group-item" [routerLink]="['products/',136]" onclick="closeCollapse()">Vasques</a>
                              </div>
                              <a class="titreSubMenu mb-2">Toilette </a>
                              <div class="list-group mb-3">
                                <a class="list-group-item" [routerLink]="['products/',14]" onclick="closeCollapse()">Cuvette wc suspendue</a>
                                <a class="list-group-item" [routerLink]="['products/',132]" onclick="closeCollapse()">Cuvette wc a poser</a>
                              </div>
                            </div>
                              <div class="col-sm-12 text-center">
                                <a href="#"><img src="assets/front/images/banners/sanitaire.jpg" alt=""></a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/plomberie.svg"/> Robinetterie</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-sm-9">
                              <div class="row">
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu">Robinetterie de salle de bain</a>
                                    <div class="list-group">
                                      <a class="list-group-item" [routerLink]="['products/',3]" onclick="closeCollapse()">Accessoires de robinetterie</a>
                                      <a class="list-group-item" [routerLink]="['products/',32]" onclick="closeCollapse()">Mélangeurs</a>
                                      <a class="list-group-item" [routerLink]="['products/',35]" onclick="closeCollapse()">Mitigeurs de baignoire</a>
                                      <a class="list-group-item" [routerLink]="['products/',36]" onclick="closeCollapse()">Mitigeurs de bidet</a>
                                      <a class="list-group-item" [routerLink]="['products/',37]" onclick="closeCollapse()">Mitigeurs de douche</a>
                                      <a class="list-group-item" [routerLink]="['products/',39]" onclick="closeCollapse()">Mitigeurs de lavabo</a>
                                      <a class="list-group-item" [routerLink]="['products/',81]" onclick="closeCollapse()">Robinets equerres</a>
                                      <a class="list-group-item" [routerLink]="['products/',82]" onclick="closeCollapse()">Robinets et becs</a>
                                    </div>
                                  <a class="titreSubMenu">Coin wc</a>
                                    <div class="list-group">
                                      <a class="list-group-item" [routerLink]="['products/',1]" onclick="closeCollapse()">Accessoires</a>
                                      <a class="list-group-item" [routerLink]="['products/',6]" onclick="closeCollapse()">Broyeurs</a>
                                      <a class="list-group-item" [routerLink]="['products/',15]" onclick="closeCollapse()">Descente de chasse</a>
                                      <a class="list-group-item" [routerLink]="['products/',16]" onclick="closeCollapse()">Douchette</a>
                                      <a class="list-group-item" [routerLink]="['products/',29]" onclick="closeCollapse()">Mécanisme de chasse encastrée</a>
                                      <a class="list-group-item" [routerLink]="['products/',30]" onclick="closeCollapse()">Mécanisme de chasse poussoir</a>
                                      <a class="list-group-item" [routerLink]="['products/',43]" onclick="closeCollapse()">Plaque de commande</a>
                                      <a class="list-group-item" [routerLink]="['products/',90]" onclick="closeCollapse()">Supports</a>
                                      <a class="list-group-item" [routerLink]="['products/',13]" onclick="closeCollapse()">Coude et rallonge wc</a>
                                      <a class="list-group-item" [routerLink]="['products/',14]" onclick="closeCollapse()">Cuvette wc suspendue</a>
                                      <a class="list-group-item" [routerLink]="['products/',132]" onclick="closeCollapse()">Cuvette wc à poser</a>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu">Robinetterie de salle de bain encastrable</a>
                                      <div class="list-group">
                                        <a class="list-group-item" [routerLink]="['products/',12]" onclick="closeCollapse()">Corps encastré</a>
                                        <a class="list-group-item" [routerLink]="['products/',18]" onclick="closeCollapse()">Ensemble de douche</a>
                                        <a class="list-group-item" [routerLink]="['products/',19]" onclick="closeCollapse()">Façade encastrée</a>
                                        <a class="list-group-item" [routerLink]="['products/',125]" onclick="closeCollapse()">Mitigeurs de lavabo encastré</a>
                                        <!-- <a class="list-group-item" [routerLink]="['products/',33]" onclick="closeCollapse()">Mitigeur de baignoire</a> -->
                                        <!-- <a class="list-group-item" [routerLink]="['products/',40]" onclick="closeCollapse()">Mitigeur de baignoire encastrable</a> -->
                                        <a class="list-group-item" [routerLink]="['products/',124]" onclick="closeCollapse()">Mitigeurs de baignoire encastré</a>
                                        <a class="list-group-item" [routerLink]="['products/',38]" onclick="closeCollapse()">Mitigeurs de douche encastré</a>
                                      </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md py-1">
                                  <a class="titreSubMenu">Collectivité</a>
                                  <div class="list-group">
                                    <a class="list-group-item" [routerLink]="['products/',2]" onclick="closeCollapse()">Accessoires de collectivité</a>
                                    <a class="list-group-item" [routerLink]="['products/',4]" onclick="closeCollapse()">Accessoires de robinetterie temporisée</a>
                                    <a class="list-group-item" [routerLink]="['products/',26]" onclick="closeCollapse()">Laboratoire</a>
                                    <a class="list-group-item" [routerLink]="['products/',41]" onclick="closeCollapse()">Personne à mobilité réduite (pmr)</a>
                                    <a class="list-group-item" [routerLink]="['products/',72]" onclick="closeCollapse()">Robinet à pédale</a>
                                    <a class="list-group-item" [routerLink]="['products/',73]" onclick="closeCollapse()">Robinet de chasse poussoir</a>
                                    <a class="list-group-item" [routerLink]="['products/',74]" onclick="closeCollapse()">Robinet infra rouge</a>
                                    <a class="list-group-item" [routerLink]="['products/',76]" onclick="closeCollapse()">Robinet poussoir de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',77]" onclick="closeCollapse()">Robinet poussoir de lavabo</a>
                                    <a class="list-group-item" [routerLink]="['products/',75]">Robinet poussoir d'urinoir</a>
                                    <a class="list-group-item" [routerLink]="['products/',126]" onclick="closeCollapse()">Douches de collectivité</a>
                                    <a class="list-group-item" [routerLink]="['products/',139]" onclick="closeCollapse()">Wc et lavabo collectif</a>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu">Douche</a>
                                  <div class="list-group">
                                    <a class="list-group-item" [routerLink]="['products/',5]" onclick="closeCollapse()">Bras de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',10]" onclick="closeCollapse()">Colonne de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',11]" onclick="closeCollapse()">Combiné de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',17]" onclick="closeCollapse()">Support de douchette</a>
                                    <a class="list-group-item" [routerLink]="['products/',21]" onclick="closeCollapse()">Flexible de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',25]" onclick="closeCollapse()">Kit de douche</a>
                                    <a class="list-group-item" [routerLink]="['products/',44]" onclick="closeCollapse()">Pomme de douche</a>
                                  </div>
                                  <a class="titreSubMenu">Vidages et siphons</a>
                                    <div class="list-group">
                                      <a class="list-group-item" [routerLink]="['products/',88]" onclick="closeCollapse()">Siphon de sol</a>
                                      <a class="list-group-item" [routerLink]="['products/',8]" onclick="closeCollapse()">Caniveaux de douche</a>
                                      <a class="list-group-item" [routerLink]="['products/',87]" onclick="closeCollapse()">Siphon de lavabo</a>
                                      <a class="list-group-item" [routerLink]="['products/',86]" onclick="closeCollapse()">Siphon de douche</a>
                                      <a class="list-group-item" [routerLink]="['products/',84]" onclick="closeCollapse()">Siphon de baignoire</a>
                                      <a class="list-group-item" [routerLink]="['products/',85]" onclick="closeCollapse()">Siphon de bidet</a>
                                    </div>
                                </div>
                              </div>
                              <div class="row">
                                  <div class="col-12 col-sm-4 col-md-3 py-1">
                                    
                                  </div>
                                  <div class="col-12 col-sm-4 col-md-3 py-1">
                                    
                                  </div>
                                </div>
                            </div>
                            <div class="col-sm-3 text-center">
                              <a class="" href="#"><img src="assets/front/images/banners/robinetterie.jpg" alt=""></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/cuisineicon.svg"/> Cuisine</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid cuisineSubMenu">
                          <div class="row justify-content-center">
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',39]" onclick="closeCollapse()" [queryParams]="{nv: 1}">Vidages Et Siphons D'Evier</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',15]" onclick="closeCollapse()" [queryParams]="{nv: 1}">Eviers</a>
                                <div class="list-group mb-3">
                                  <a class="list-group-item" [routerLink]="['products/',146]" onclick="closeCollapse()">Éviers sous plan</a>
                                  <a class="list-group-item" [routerLink]="['products/',145]" onclick="closeCollapse()">Éviers encastrable</a>
                                  <a class="list-group-item" [routerLink]="['products/',147]" onclick="closeCollapse()">Éviers à poser</a>
                                </div>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',42]" onclick="closeCollapse()" [queryParams]="{nv: 1}">Robinets de cuisine de collectivité</a>
                            </div>
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2">Robinetterie de cuisine</a>
                                <div class="list-group mb-3">
                                  <a class="list-group-item" [routerLink]="['products/',34]" onclick="closeCollapse()">Mitigeurs d'évier</a>
                                  <a class="list-group-item" [routerLink]="['products/',31]" onclick="closeCollapse()">Mélangeurs d’évier</a>
                                </div>
                            </div>
                              <div class="col-sm-12 text-center">
                                <!-- <a href="#"><img src="assets/front/images/banner2.png" alt=""></a> -->
                                <a href="#"><img src="assets/front/images/banners/cuisine.jpg" alt=""></a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img _ngcontent-lqf-c53="" src="assets/front/images/carrelage.svg" style="width: 19px;height: 25px;"> Carrelage</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid cuisineSubMenu">
                          <div class="row justify-content-center" style="width: 150%;">
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',50]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet pierre sol et mur</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',51]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet marbre sol et mur</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',52]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet bois sol et mur</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',53]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet beton sol et mur</a>
                            </div>
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',54]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet pierre mural </a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',55]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage effet marbre mural</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',56]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Carrelage grand format</a>
                            </div>
                              <div class="col-sm-12 text-center">
                                <a href="#"><img src="assets/front/images/banners/carrelage-banner.jpg" alt=""></a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/plomberie.svg" alt=""> Plomberie</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-sm-9">
                              <div class="row">
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',3]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Ballon D'Expension Et Membranes</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',7]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Collecteurs</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',9]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Colliers De Fixation</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',10]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Compteurs D'Eau</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',12]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Électrovannes et vannes motorisées</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',14]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Étanchéité et adhésifs</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',23]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Outils Et Machines</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',17]" [queryParams]="{nv: 1}">Flexibles</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',20]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Gargouilles</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',26]" [queryParams]="{nv: 1}">Resistance Et Thermostat</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',31]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Rosaces</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',33]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Soudure Et Chalumeaux</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',37]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Vannes</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',40]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Visserie Et Fixation</a>
                                  <a class="titreSubMenu mb-2" [routerLink]="['products/',43]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Séparateur hydrocarbure</a>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu">Tubes Et Raccords De Plomberie</a>
                                    <div class="list-group">
                                      <a class="list-group-item" [routerLink]="['products/',55]" onclick="closeCollapse()">Raccords De Climatisation</a>
                                      <a class="list-group-item" [routerLink]="['products/',56]" onclick="closeCollapse()">Raccords En Cuivre</a>
                                      <a class="list-group-item" [routerLink]="['products/',57]" onclick="closeCollapse()">Raccords En Fonte</a>
                                      <a class="list-group-item" [routerLink]="['products/',58]" onclick="closeCollapse()">Raccords en fonte malléable galvanise</a>
                                      <a class="list-group-item" [routerLink]="['products/',59]" onclick="closeCollapse()">Raccords en fonte malléable Noir</a>
                                      <a class="list-group-item" [routerLink]="['products/',60]" onclick="closeCollapse()">Raccords En Laiton</a>
                                      <a class="list-group-item" [routerLink]="['products/',61]" onclick="closeCollapse()">Raccords En Laiton Compteur</a>
                                      <a class="list-group-item" [routerLink]="['products/',62]" onclick="closeCollapse()">Raccords En Laiton Ogive</a>
                                      <a class="list-group-item" [routerLink]="['products/',63]" onclick="closeCollapse()">Raccords En Laiton Pehd</a>
                                      <a class="list-group-item" [routerLink]="['products/',64]" onclick="closeCollapse()">Raccords En Laiton Retube</a>
                                      <a class="list-group-item" [routerLink]="['products/',66]" onclick="closeCollapse()">Raccords en laiton retube à sertir </a>
                                      <a class="list-group-item" [routerLink]="['products/',67]" onclick="closeCollapse()">Raccords En Pvc</a>
                                      <a class="list-group-item" [routerLink]="['products/',68]" onclick="closeCollapse()">Raccords Ppr</a>
                                      <a class="list-group-item" [routerLink]="['products/',92]" onclick="closeCollapse()">Tubes En Cuivre En Barre</a>
                                      <a class="list-group-item" [routerLink]="['products/',93]" onclick="closeCollapse()">Tubes En Cuivre En Couronne</a>
                                      <a class="list-group-item" [routerLink]="['products/',94]" onclick="closeCollapse()">Tubes En Fonte</a>
                                      <a class="list-group-item" [routerLink]="['products/',95]" onclick="closeCollapse()">Tubes Ppr</a>
                                      <a class="list-group-item" [routerLink]="['products/',128]" onclick="closeCollapse()">Tubes phonoblack</a>
                                      <a class="list-group-item" [routerLink]="['products/',96]" onclick="closeCollapse()">Tubes réticulés</a>
                                      <a class="list-group-item" [routerLink]="['products/',123]" onclick="closeCollapse()">Tubes et raccords de plomberie</a>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3 py-1">
                                  <a class="titreSubMenu mt-3">Protection Des Installations</a>
                                  <div class="list-group">
                                    <!-- <a class="list-group-item" [routerLink]="['products/',131]" onclick="closeCollapse()">Protection Des Installations</a> -->
                                    <a class="list-group-item" [routerLink]="['products/',9]" onclick="closeCollapse()">Clapets et crépines</a>
                                    <a class="list-group-item" [routerLink]="['products/',20]" onclick="closeCollapse()">Filtre A Tamis</a>
                                    <a class="list-group-item" [routerLink]="['products/',28]" onclick="closeCollapse()">Manometres Et Thermometres</a>
                                    <a class="list-group-item" [routerLink]="['products/',53]" onclick="closeCollapse()">Purgeurs et contrôleurs d’air </a>
                                    <a class="list-group-item" [routerLink]="['products/',69]" onclick="closeCollapse()">Réducteur de pression </a>
                                    <a class="list-group-item" [routerLink]="['products/',89]" onclick="closeCollapse()">Soupapes</a>
                                    <a class="list-group-item" [routerLink]="['products/',135]" onclick="closeCollapse()">Goulottes</a>
                                  </div>
                                  <a class="titreSubMenu mt-3">Robinetterie De Batiment</a>
                                  <div class="list-group">
                                    <a class="list-group-item" [routerLink]="['products/',78]" onclick="closeCollapse()">Robinet d’arrêt</a>
                                    <a class="list-group-item" [routerLink]="['products/',79]" onclick="closeCollapse()">Robinet d’arrosage</a>
                                    <a class="list-group-item" [routerLink]="['products/',83]" onclick="closeCollapse()">Robinet flotteur</a>
                                    <a class="list-group-item" [routerLink]="['products/',91]" onclick="closeCollapse()">Tetes De Robinet</a>
                                    <a class="list-group-item" [routerLink]="['products/',80]" onclick="closeCollapse()">Robinet de puisage</a>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-3 py-1">
                                  <a class="titreSubMenu">Accessoires Pour Pompes</a>
                                  <div class="list-group">
                                    <a class="list-group-item" [routerLink]="['products/',54]" onclick="closeCollapse()">Raccords 5 voies</a>
                                    <a class="list-group-item" [routerLink]="['products/',71]" onclick="closeCollapse()">Régulateur de control </a>
                                    <a class="list-group-item" [routerLink]="['products/',22]" onclick="closeCollapse()">Flotteur électrique</a>
                                    <a class="list-group-item" [routerLink]="['products/',52]" onclick="closeCollapse()">Pressostats</a>
                                  </div>
                                  <a class="titreSubMenu mt-3">Traitement Des Eaux Et Assainissement</a>
                                  <div class="list-group">
                                    <a class="list-group-item" [routerLink]="['products/',7]" onclick="closeCollapse()">Caniveaux</a>
                                    <a class="list-group-item" [routerLink]="['products/',23]" onclick="closeCollapse()">Fonds De Naissance</a>
                                    <a class="list-group-item" [routerLink]="['products/',24]" onclick="closeCollapse()">Fosse Septique</a>
                                    <a class="list-group-item" [routerLink]="['products/',42]" onclick="closeCollapse()">Piquages</a>
                                    <a class="list-group-item" [routerLink]="['products/',70]" onclick="closeCollapse()">Regards</a>
                                    <!-- <a class="list-group-item" [routerLink]="['products/',122]" onclick="closeCollapse()">Traitement des eaux et assainissement</a> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-3 text-center">
                              <!-- <a class="" href="#"><img src="assets/front/images/banner3.svg" alt=""></a> -->
                              <a class="" href="#"><img src="assets/front/images/banners/plomberie.jpg" alt=""></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/chauffageicon.svg" alt=""> Chauffage</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid cuisineSubMenu">
                          <div class="row justify-content-center">
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',4]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Chauffe-eau électrique</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',13]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Éléments de radiateur</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',25]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Resistance Et Thermostat</a>
                            </div>
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',5]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Chauffe Eau Solaire </a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',21]" [queryParams]="{nv: 1}">Groupe de sécurité</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',32]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Sèche serviettes électrique</a>
                            </div>
                              <div class="col-sm-12 text-center">
                                <!-- <a href="#"><img src="assets/front/images/banner4.svg" alt=""></a> -->
                                <a href="#"><img src="assets/front/images/banners/chauffage.jpg" alt=""></a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown dropdown-mega position-static">
                    <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside"><img src="assets/front/images/aerationicon.svg" alt=""> Aeration, ventilation et isolation</a>
                    <div class="dropdown-menu shadow">
                      <div class="mega-content px-4">
                        <div class="container-fluid cuisineSubMenu">
                          <div class="row justify-content-center">
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',16]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Extracteur d’air</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',19]" [queryParams]="{nv: 1}">Gaine Flexible En Alluminum</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',35]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Tubes Isolant Armaflex</a>
                            </div>
                            <div class="col-sm-6">
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',18]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Gaine Calorifuge</a>
                              <a class="titreSubMenu mb-2" [routerLink]="['products/',22]" [queryParams]="{nv: 1}" onclick="closeCollapse()">Laine De Verre</a>
                            </div>
                              <div class="col-sm-12 text-center">
                                <!-- <a href="#"><img src="assets/front/images/banner6.svg" alt=""></a> -->
                                <a href="#"><img src="assets/front/images/banners/aération.jpg" alt=""></a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item" >
                    <a class="nav-link" style="color: #dc3545;font-weight: 600;" routerLink="/promos" >Promos</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLink="/robimeds">Robimed®</a>
                  </li>
                  
                  <!-- <li class="nav-item">
                    <a class="nav-link" routerLink="/marques">Marques</a>
                  </li> -->
                  <!-- <li class="nav-item">
                    <a class="nav-link" routerLink="/series">Séries</a>
                  </li> -->
                </ul>
                </nav>
          <div class="theSeparator d-md-none d-lg-block"></div>
              </div>
        </div>
      <!-- </div> -->

</header>

<div class="searchContainer" style="display:none;">
  <div class="searchBox">
    <div class="row">
      <div class="Searching col-12">
        <div class="closeSearch">×</div>
        <div class="mt-3">
          <h5>Recherche par mots clés</h5>
          <div class="separApropos"></div>
          <input type="text" class="form-control searchForm" [(ngModel)]="searchField" (change)="search()" placeholder="Recherche...">
          <button class="searchBtn" (click)="search()"><i class="fa fa-search" aria-hidden="true"></i></button>
        </div>
        <div class="catSearch noSearchMobile">
          <h5 class="mt-3">Catégories</h5>
          <div class="separApropos"></div>
          <ul>
            <li *ngFor="let cat of selectedCategories.slice(0, 5)"><a [routerLink]="['products/',cat?.id]"  class="catLinks" onclick="hideSearchBox()">{{cat?.titre}}</a></li>
          </ul>
        </div>
        <div class="catSearch noSearchMobile">
          <h5 class="mt-3">Fournisseur</h5>
          <div class="separApropos"></div>
          <ul>
            <li *ngFor="let four of selectedFournisseurs.slice(0,5)"><a [routerLink]="['marque/',four?.id]"  class="catLinks" onclick="hideSearchBox()">{{four?.titre}}</a></li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-md-8 catSearch">
        <div class="row g-1">
          <div *ngFor="let product of selectedProducts?.produits?.slice(0, 8)" class="col-sm-3 showProductSearch">
            <div class="newProductContainer">
              <a  [routerLink]="['product-details/',product?.ITMREF]" onclick="hideSearchBox()" class="ProductImgContainer">
                <img src="https://ceratube.ma/ceratube/assets/images/product-img/{{product?.VIG}}" class="img-fluid ProductImg">
              </a>
              <div class="productData">
                <div class="productIcons text-center">
                  <!-- <a href="#" class="likeAction productActions">
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                    </span>
                  </a> -->
                  <a [routerLink]="['product-details/',product?.ITMREF]"  class="viewAction productActions">
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <!-- <a href="#" class="addtocartAction productActions">
                    <div class="viewAction">
                      <span class="fa-stack fa-lg">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                      </span>
                    </div>
                  </a> -->
                </div>
                <a [routerLink]="['product-details/',product.ITMREF]" onclick="hideSearchBox()" class="productDetails">
                  <div class="productTitle text-center">
                    {{product?.ITMDES1}}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div *ngFor="let product of selectedProducts?.produits?.slice(0, 8)" class="col-12 col-lg-3 showProductSearchMobile">
            <div class="newProductContainerMobile">
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-2 text-center">
                    <a  [routerLink]="['product-details/',product?.ITMREF]" onclick="hideSearchBox()">
                      <img src="https://ceratube.ma/ceratube/assets/images/product-img/{{product?.VIG}}" class="img-fluid">
                    </a>
                  </div>
                  <div class="col-10 productMobileTitle">
                    <a  [routerLink]="['product-details/',product?.ITMREF]" onclick="hideSearchBox()">
                      {{product?.ITMDES1}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flash text-center" *ngIf="!selectedProducts">
            <img src="assets/front/images/logo.png"/>
          </div>
          <div class="flash text-center" *ngIf="selectedProducts?.total ==0">
            <img src="assets/front/images/logo.png"/>
          </div>
          <a [routerLink]="['search/',searchField]"  class="col-12 searchPlus text-center p-2 d-block">
            Voir tout les résultats ({{selectedProducts?.total}})
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
